import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageMeta, trackVisit } from '../../services/analytics';

const VisitorTracker = () => {
  const location = useLocation();
  const enteredAtRef = useRef(Date.now());
  const previousMetaRef = useRef(null);

  useEffect(() => {
    const currentMeta = getPageMeta(location.pathname, location.hash);
    const durationSeconds = Math.max(0, Math.round((Date.now() - enteredAtRef.current) / 1000));

    if (previousMetaRef.current) {
      trackVisit({
        ...previousMetaRef.current,
        durationSeconds,
      });
    } else {
      trackVisit({
        ...currentMeta,
        durationSeconds: 0,
      });
    }

    previousMetaRef.current = currentMeta;
    enteredAtRef.current = Date.now();
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const handleLeave = () => {
      if (!previousMetaRef.current) return;
      const durationSeconds = Math.max(0, Math.round((Date.now() - enteredAtRef.current) / 1000));
      trackVisit({
        ...previousMetaRef.current,
        durationSeconds,
      });
    };

    window.addEventListener('beforeunload', handleLeave);
    return () => window.removeEventListener('beforeunload', handleLeave);
  }, []);

  return null;
};

export default VisitorTracker;
